import { render, staticRenderFns } from "./HealthConversationTemplateEditor.vue?vue&type=template&id=f7b5f124&scoped=true&lang=pug"
import script from "./HealthConversationTemplateEditor.vue?vue&type=script&lang=js"
export * from "./HealthConversationTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./HealthConversationTemplateEditor.vue?vue&type=style&index=0&id=f7b5f124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b5f124",
  null
  
)

export default component.exports